"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderReviewQueue = orderReviewQueue;
/**
 * FP-182 (Paul, 2026-10-09): every Review opens the review wizard, and someone who
 * taps it to fix this period's spending must land on THAT spending, not on a queue
 * that starts in another month or on money that came in. So the current pay period's
 * uncategorised OUTFLOWS come first, in the order given; everything else follows,
 * also in the order given. Stable: nothing else about the queue changes.
 *
 * Two reasons, both load-bearing (keep them):
 * - This period's SPENDING first, never money that came in: the line a Review is tapped
 *   from counts outflows, so an in-period refund or transfer in must not lead.
 * - The server already returns the queue newest-first, so in practice the main effect
 *   is putting this period's spending ahead of in-period INFLOWS, which are just as
 *   new. Without an in-period inflow the order looks unchanged; that is not a sign the
 *   rule is redundant (#1902's device check needed one to see it).
 *
 * One rule for both clients (agreed with web, 2026-10-11; rule 17), in place of two
 * copies with the same cases: mobile's now wraps this, and web's `lib/reviewQueueOrder.ts`
 * switches to it in web's own follow-up. The
 * clients' rows differ, so each passes how to read a row:
 * - `isOutflow`: web's `!isInflow(t)` keeps the demo seed's opposite sign; mobile's
 *   `!moneyIn(t)` reads the adapter's `isInflow`.
 * - `date`: the row's API date. Compared on its first 10 characters, so a timestamp
 *   works too; the period's last day counts.
 *
 * An unknown period (no remainder yet, or none sent) leaves the queue as it was.
 */
function orderReviewQueue(rows, period, row) {
    if (!period?.start || !period.end)
        return [...rows];
    const inPeriodSpending = (t) => {
        const day = row.date(t).slice(0, 10);
        return row.isOutflow(t) && day >= period.start && day <= period.end;
    };
    return [
        ...rows.filter(inPeriodSpending),
        ...rows.filter((t) => !inPeriodSpending(t)),
    ];
}
//# sourceMappingURL=reviewQueueOrder.js.map